import { render } from "./UiRecaptcha.vue?vue&type=template&id=52a4582c&ts=true&lang=pug"
import script from "./UiRecaptcha.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiRecaptcha.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__